import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, of, map } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

interface PostContent {
  rendered: string | SafeHtml;
}
interface PostEmbedded {
  author: Author[];
}
interface Author {
  name: string;
  url: string;
}

interface PostData {
  id: number;
  content: PostContent;
  title: PostContent;
  date: string;
  _embedded: PostEmbedded[];
}

@Injectable({
  providedIn: 'root'
})

export class WordpressRetrieveService {
  parsedContent: Document | null = null;
  baseUrl: String = 'https://www.venturabirthandbreastfeeding.com/wp-json/wp/v2/';

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  getAllPosts():Observable<any>
  {
    return this.http.get(this.baseUrl+'posts?_embed');
  }
  
        
        
  getPostById(id:String):Observable<PostData>
  {
    var feature : PostData;
    var renderedContent : any;
    var sanitizedHtml : SafeHtml;

    let url = this.baseUrl + 'posts/' + id + "?_embed";
    //console.log ("url is: ", url);
    return this.http.get<PostData>(url).pipe(map((data) => {
      //console.log("feature retrieved by service is:");
      //console.log(data);
      feature=data;
      renderedContent = data.content.rendered;
      const parser = new DOMParser();
      this.parsedContent = parser.parseFromString(renderedContent, "text/html");
      //console.log ("parsed content: ");
      //console.log (this.parsedContent);
      this.modifyEmbeds();
      const serializer = new XMLSerializer();
      renderedContent = serializer.serializeToString(this.parsedContent);
      //console.log ("new content");
      //console.log(renderedContent);
      sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(renderedContent);
      feature.content.rendered = sanitizedHtml;
      return feature;
    }));
  }
 modifyEmbeds(): void {
    if (this.parsedContent) {
      const figures = this.parsedContent.querySelectorAll('figure');
      figures.forEach((figure) => {
        //console.log ("unmodified figure");
        //console.log (figure);
        const images = figure.querySelectorAll('img');
        //console.log ("images");
        //console.log (images);
        images.forEach((img) => {
          img.style.maxWidth = '600px';
          img.style.width = '100%';
          img.style.height = 'auto'; // Maintain the aspect ratio of the image
          img.setAttribute('sizes', '(max-width: 600px) 90vw, 600px');
          img.removeAttribute('width');
          img.removeAttribute('height');
          //console.log ("modified image");
          //console.log (img);
        });
        const divs = figure.querySelectorAll('div');
        //console.log ("images");
        //console.log (images);
        divs.forEach((div) => {
          const iframes = figure.querySelectorAll('iframe');
          iframes.forEach((iframe) => {
            //console.log ("iframe");
            //console.log (iframe);
            // Create a new <object> element
            const objectElement = document.createElement('object');
            objectElement.style.width = '600px';
            objectElement.style.height = '316px';
            objectElement.style.float = 'none';
            objectElement.style.clear = 'both';
            objectElement.style.margin = '2px auto';
            
            // Set the data attribute from the iframe's src
            objectElement.data = iframe.src;

            // set a fallback anchor
            objectElement.addEventListener('error', () => {
              // Create a fallback <a> element
              const fallbackLink = document.createElement('a');
              fallbackLink.href = iframe.src;
              fallbackLink.textContent = iframe.title;
              // Replace the <object> with the <a> element
              objectElement.parentNode?.replaceChild(fallbackLink, objectElement);
            });
            
            // Replace the figure with the new object element
            figure.parentNode?.replaceChild(objectElement, figure);
          });
          //console.log ("new div");
          //console.log (div);
        }); 
      });
      // modify all anchors to open external windows
      const anchors = this.parsedContent.querySelectorAll('a');
      anchors.forEach((anchor) => {
        anchor.setAttribute('target', '_newresourcewindow');
      });
    }
  }
}
